export const LANGUAGE_CODE = "language_code";
export const REDIRECT_AFTER_CONFIRM_URL = "redirect_after_confirm_url";
export const REDIRECT_URL = "charge_orders/%ORDER_ID%/payment_request";
export const ORDER_ID_REGEX = /%ORDER_ID%/g;
export const PARENT_REGEX = /%PARENT%/g;
export const CALLBACK = "/#/eshop/status/%ORDER_ID%";
export const CALLBACK_URL = "%PROTOCOL%//%HOSTNAME%%PORT%%CALLBACK%";
export const SPINNER = "/wp-content/themes/edaz/spinner.html";
export const PROTOCOL_REGEX = /%PROTOCOL%/g;
export const HOSTNAME_REGEX = /%HOSTNAME%/g;
export const PORT_REGEX = /%PORT%/g;
export const CALLBACK_REGEX = /%CALLBACK%/g;
